window.addEventListener('load', () => {
	let cards = document.querySelectorAll('.product-grid .product-grid__item .card-wrapper .card--product .card__inner');
	let cardSliders = document.querySelectorAll('.product-grid .product-grid__item .card-wrapper .card--product .card__inner .card-image-slider');

	addCardFunctionalities(cards, cardSliders);
});


function between(x, min, max) {
	return x >= min && x <= max;
}


function addCardFunctionalities(cards, cardSliders) {
	if (!cards.length || !cardSliders.length){
		return console.warn('No card-sliders found')
	};
	cardSliders.forEach((slider) => {
		const sliderBar = slider.querySelector('.slider-bar');
		const sliderBarParts = sliderBar.querySelectorAll('.slider-bar-part');
		if (sliderBarParts.length < 2 || slider.dataset.disableScroll === 'true') sliderBar.style.display = 'none';

		if (slider.dataset.disableScroll !== 'true') {
			sliderBarParts.forEach((part, index) => {
				part.addEventListener('click', () => {
					slider.scrollTo({
						left: slider.querySelector(`.card-image-slide[data-slide-index="${index}"]`).offsetLeft,
						behavior: 'smooth'
					});
				});
			});

			slider.addEventListener('scroll', () => {
				let currentScrollDistance = slider.scrollLeft;	
				
				let slides = slider.querySelectorAll('.card-image-slide');
				
				if (!slides || !currentScrollDistance) return;
				slides.forEach(slide => {
					if (between(currentScrollDistance, slide.offsetLeft - 50, slide.offsetLeft + 50)) {
						let dataSlideIndex =  parseInt(slide.getAttribute('data-slide-index'));
						
						sliderBarParts.forEach(part => {
							if (part.classList.contains('active')) return part.classList.remove('active')
						});
                    	
						sliderBarParts[dataSlideIndex].classList.add('active');
					}
				});
			});
		} else {
			slider.style.overflowX = 'hidden';

			// Horizontal swipe is reserved for the outer product slider, so on touch
			// devices let users browse the card's images by TAPPING the left/right
			// half of the image instead (no dots). Desktop keeps click -> PDP + hover.
			const isTouch = window.matchMedia('(pointer: coarse)').matches;
			const tapSlides = slider.querySelectorAll('.card-image-slide');
			if (isTouch && tapSlides.length > 1) {
				let tapIndex = 0;
				slider.addEventListener('click', (e) => {
					// Preempt the image's inline onclick navigation; tap browses instead.
					e.preventDefault();
					e.stopPropagation();
					const rect = slider.getBoundingClientRect();
					const x = e.clientX - rect.left;
					if (x < rect.width / 2) {
						tapIndex = (tapIndex - 1 + tapSlides.length) % tapSlides.length;
					} else {
						tapIndex = (tapIndex + 1) % tapSlides.length;
					}
					slider.scrollTo({ left: tapSlides[tapIndex].offsetLeft, behavior: 'smooth' });
				}, true);
			}
		}

		const cardImages = slider.querySelectorAll('.card-image-slide img');
		if (cardImages.length < 2) return;

		const windowWidthOnLoad = window.innerWidth;
		let swapped = false;

		const no_model = slider.getAttribute('data-model');

		const slides = slider.querySelectorAll('.card-image-slide');

		window.addEventListener('resize', () => {
			if (!no_model === 'true') return;

			if (window.innerWidth >= 990) {
				sliderBarParts.forEach((part) => {
					if (part.classList.contains('active')) part.classList.remove('active');
				});
	
				sliderBarParts[0].classList.add('active');
	
				slider.scrollTo({
					left: slides[0].offsetLeft
				});
			}
		});

		if (no_model === 'true') return;

	});
}

function isInViewport(element) {
	const rect = element.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

/**
 *
 * @param {Object} imageA - img tag
 * @param {Object} imageB - img tag
 */
function swapImageAttributes(imageA, imageB) {
	const imgA = {
		src: imageA.src,
		srcset: imageA.srcset,
		alt: imageA.alt,
		onclick: imageA.onclick,
	};

	const imgB = {
		src: imageB.src,
		srcset: imageB.srcset,
		alt: imageB.alt,
		onclick: imageB.onclick,
	};

	imageB.src = imgA.src;
	imageB.srcset = imgA.srcset;
	imageB.alt = imgA.alt;
	imageB.onclick = imgA.onclick;

	imageA.src = imgB.src;
	imageA.srcset = imgB.srcset;
	imageA.alt = imgB.alt;
	imageA.onclick = imgB.onclick;
}
